export const getStatus = (state) => {
  switch (state) {
    case "Registered":
      return "Registrerad";
    case "Charged":
      return "Aktiv";
    case "Charged failed":
      return "Misslyckad dragning";
    case "Cancelled":
    case "Aborted":
      return "Avbruten";
    case "Frozen":
      return "Fryst";
    default:
      return "-";
  }
};

export const getChargeStatus = (status) => {
  switch (status) {
    case "Charged":
      return "Betald";
    case "Failed":
      return "Missad";
    case "Due":
      return "Kommande";
    case "Cancelled":
      return "Makulerad";
    default:
      return "-";
  }
};

export const getFormattedAmount = (amount) => {
  if (!amount) return "";

  const convertedAmount = amount / 100;

  if (Number.isInteger(convertedAmount)) {
    return `${convertedAmount},00 kr`;
  } else {
    return `${convertedAmount} kr`;
  }
};

export const getTermType = (termType, charges) => {
  switch (termType) {
    case "FixedTerm":
      return `Bundet ${
        charges.length > 0 ? `(${charges.length} dragningar)` : ""
      } `;
    case "Ongoing":
      return "Löpande";
    default:
      return "";
  }
};

export const getNextPayment = (charges) => {
  if (!charges) return;
  const nextCharge = charges.filter((charge) => charge.status === "Due")[0];
  if (!nextCharge) return;
  const date = nextCharge.dueDate.split("T")[0];
  return date;
};

export const handleCancel = (
  TOAST,
  setLoading,
  dispatch,
  cancelled,
  errorMsg
) => {
  const text = cancelled
    ? "Abonnemanget borttaget, sidan laddas om"
    : `Ett fel inträffade ${errorMsg ? `- ${errorMsg}` : ""}`;
  dispatch({
    type: TOAST,
    payload: {
      text,
      variant: cancelled ? "success" : "error",
    },
  });

  if (cancelled) {
    setLoading(true);
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }
};

export const checkIfFinalized = (
  subscriptionTermType,
  paidCharges,
  charges,
  nextPayment
) => {
  return (
    subscriptionTermType === "FixedTerm" &&
    paidCharges.length === charges.length &&
    !nextPayment
  );
};
